import axios from '@/plugins/http/axios.js';
import config from "@/views/suppliers/config/suppliers_api.js";
import PathUri from '@/utils/path_uri';

const _pathUri = new PathUri(config.port, config.context);


export const service = {
    getSuppliers: (idGroup, idEmpresa, idUsuario) => {
        return axios({
            method: 'get',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/suppliers`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },

     upDateSuppliers: ({ idGroup, idEmpresa, idUsuario, suppliers }) => {
        return axios.put(
             `${config.baseUrl + _pathUri.generateUri() + idGroup}/useititr`,
             {
                 ...suppliers,
                 status: true,
 
             },
             {
                 headers: {
                     'Content-Type': 'application/json',
                     'idEmpresa': idEmpresa,
                     'idUsuario': idUsuario
                 }
             }
         )
     },


     getSuppliersDelete: (idGroup, idEmpresa, idUsuario, supplierId) => {
        return axios({
            method: 'delete',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/suppliers/${supplierId}`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },
}
